import Axios from './APIService';
import { AxiosPromise, AxiosRequestConfig } from 'axios';

import Paying from '@/types/Paying';

const admin = '/admin';

const apiBase = '/payings';

const paymentAPI = {

    get(): AxiosPromise<Paying[]> {
        return Axios.get(apiBase);
    },

    post(paying: Paying): AxiosPromise<Paying> {
        return Axios.post(`${admin}${apiBase}`, paying);
    },

    delete(payingId: string): AxiosPromise<Paying> {
        return Axios.delete(`${admin}${apiBase}/${payingId}`);
    }

};

export default paymentAPI;
